import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { match } from 'path-to-regexp';

function isPathMatched(allowedPath, currentPath) {
  const matcher = match(allowedPath, { decode: decodeURIComponent });
  return matcher(currentPath) !== false;
}

function isPathAllowed(pages = [], pathname) {
  for (const page of pages) {
    if (isPathMatched(page.path, pathname)) return true;
    if (page.children && isPathAllowed(page.children, pathname)) return true;
  }
  return false;
}

export default function PageProtectedRoute({ children }) {
  const { user, menus, loadingUser, loadingMenus } = useAuth();
  const location = useLocation();

  if (loadingUser || loadingMenus) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const allowed = isPathAllowed(menus, location.pathname);
  if (!allowed) {
    console.warn(`🚫 Access denied for path: ${location.pathname}`);
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}